import tokenData from '../../design-tokens/base-tokens.json';
const MuiCheckbox = {
    defaultProps: {
        disableRipple: true
    },
    styleOverrides: {
        root: {
            padding: 0,
            color: tokenData.tokens.palette.grey.grey500,
            '&.Mui-disabled': {
                color: tokenData.tokens.palette.grey.disabled,
                pointerEvents: 'unset',
                cursor: 'not-allowed',
                '&:hover': {
                    outline: 'none'
                }
            },
            '&.Mui-checked': {
                color: tokenData.tokens.palette.blue.blue500,
                '&.Mui-disabled': {
                    color: tokenData.tokens.palette.grey.disabled
                }
            },
            '&:hover': {
                outlineStyle: 'solid',
                outlineWidth: '2px',
                outlineColor: tokenData.tokens.palette.blue.blue500,
                borderRadius: '4px',
                WebkitBorderRadius: '4px'
            },
            '&.Mui-focusVisible': {
                border: `2px solid #000000`,
                margin: '-2px',
                borderRadius: '4px',
                WebkitBorderRadius: '4px'
            },
            '& .MuiSvgIcon-root': {
                fontSize: 20
            }
        },
        sizeSmall: {
            '& .MuiSvgIcon-root': {
                fontSize: 18
            }
        }
    }
};
export default MuiCheckbox;
